module.exports = __webpack_public_path__ + "img/tospaa-p01.bcff6099.png";